<section id="services" class="services" #element>
  <div class="component-content">
    <h1 class="services__title">{{headline}}</h1>
    <div class="services__description" [innerHtml]="description">
    </div>
  </div>
</section>